"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LearningPathLevel = exports.LearningPathContentType = void 0;
var LearningPathContentType;
(function (LearningPathContentType) {
    LearningPathContentType["LESSON"] = "lesson";
    LearningPathContentType["COURSE"] = "course";
    LearningPathContentType["CHALLENGE"] = "challenge";
    LearningPathContentType["SYSTEM_ASSESSMENT"] = "systemAssessment";
})(LearningPathContentType = exports.LearningPathContentType || (exports.LearningPathContentType = {}));
var LearningPathLevel;
(function (LearningPathLevel) {
    LearningPathLevel["BASIC"] = "basic";
    LearningPathLevel["ADVANCED"] = "advanced";
    LearningPathLevel["EXPERT"] = "expert";
})(LearningPathLevel = exports.LearningPathLevel || (exports.LearningPathLevel = {}));
